import { SponsorRouteData } from './sponsor-route-data';
import { Injectable } from '@angular/core';
import { UrlBuilder } from '../core';
import { LabTestResultsLinkBuilder } from '../subjects/lab-test-results-link-builder';
import { SponsorStudy } from '../sponsor-dashboard/sponsor-study';
import { LabTestResult } from '../lab-test-results';
import { LinkParams } from '../covance-ag-grid';
import { StandardTestResultsItem } from '../on-screen-results/standard-test-results/standard-test-results.component';

@Injectable()
export class SponsorLabTestResultsLinkBuilder implements LabTestResultsLinkBuilder {

    private readonly currentStudy: SponsorStudy;
    
    constructor(private urlBuilder: UrlBuilder, routeData: SponsorRouteData) {
    this.currentStudy = routeData.snapshot.selectedStudy;
    }

    public getAccessionNumberLink(lab: LabTestResult): LinkParams {

        return {
            routerLink: this.urlBuilder
                .esa()
                .sponsor()
                .study(this.currentStudy)
                .testResults(lab.subjectSiteId)
                .url(),
            queryParams: { accessionNumber: `["${lab.accessionNumber}"]` },
            text: lab.accessionNumber,
            toString: () => lab.accessionNumber || ''
        } as LinkParams;
    }

    public getTestLink(lab: LabTestResult): LinkParams {
        return {
            routerLink: this.urlBuilder
                .esa()
                .sponsor()
                .study(this.currentStudy)
                .trendAnalysis({zcTestCode: lab.zcTestCode, name: lab.testNameWithUnit})
                .url(),
            text: lab.test,
            toString: () => lab.test,
            queryParams: { test: `["${lab.zcTestCode}"]` }
        } as LinkParams;
    }

    public getSubjectLink(params: StandardTestResultsItem) {
        const routerLink: any = params.data && params.data.zcSubjectId ?
            this.urlBuilder.esa().sponsor().study(this.currentStudy).subjects(params.data.zcSubjectId, 'lab-tests-grid').url()
            : [];
        return routerLink;
    }
}